import { HttpDeprecatedService } from '@commons/core/transport/http-deprecated.service';
import { IPageDataWithNbTotal, IPaginationInfo } from '@commons/util/utilities/table-model';
import { ILogService, IPromise } from 'angular';

import { SOCIAL_NETWORK_FACADE_PREFIX } from '@contact/upgrade';

const MODULE_NAME = 'socialNetworkService';

export type SocialNetworkType = 'FACEBOOK' | 'FACEBOOK_MESSENGER' | 'TWITTER' | 'ALL';

export interface ISocialNetworkIdentity {
  id: string;
  firstname: string;
  lastname: string;
  screenname: string;
  avatarUrl: string;
  cngType: SocialNetworkType;
  displayName: string;
}

export interface ISocialNetworkService {
  getExchangeHisto(dimeloRequestId: string): IPromise<any>;

  searchInDimeloEntities(
    text: string,
    type: SocialNetworkType,
    paginationInfo: IPaginationInfo
  ): IPromise<IPageDataWithNbTotal<ISocialNetworkIdentity>>;
}

export class SocialNetworkService implements ISocialNetworkService {
  static $inject: Array<string> = ['$log', 'httpDeprecated'];

  constructor(protected readonly $log: ILogService, private readonly httpDeprecated: HttpDeprecatedService) {}

  getExchangeHisto(contentThreadId: string): IPromise<any> {
    return this.httpDeprecated
      .asPromise()
      .get(SOCIAL_NETWORK_FACADE_PREFIX + '/getContentThreadInteraction', [contentThreadId])
      .then(result => {
        // TODO build DTO
        this.buildExchangeSocialNetwork(result.data);
        return result.data;
      });
  }

  buildExchangeSocialNetwork(data) {
    if (!!data) {
      if (!!data.exchange && data.exchange.length !== 0) {
        for (let i = 0; i < data.exchange.length; i++) {
          data.exchange[i].createdAt = new Date(data.exchange[i].createdAt);
        }
      }
    }
    return data;
  }

  searchInDimeloEntities(
    text: string,
    type: SocialNetworkType,
    paginationInfo: IPaginationInfo
  ): IPromise<IPageDataWithNbTotal<ISocialNetworkIdentity>> {
    return this.httpDeprecated
      .asPromise()
      .withConfig({ headers: { 'Content-Type': 'text/plain; charset=UTF-8' } })
      .withData(paginationInfo)
      .post(SOCIAL_NETWORK_FACADE_PREFIX + '/findIdentitiesThatContains', [text, type])
      .then(result => {
        let paginationData: IPageDataWithNbTotal<ISocialNetworkIdentity> = {
          pageData: [],
          nbTotalItems: 0,
        };
        if (result.data && result.data.pageData && result.data.pageData.length > 0) {
          for (let item of result.data.pageData) {
            let dto: ISocialNetworkIdentity = {
              id: item.id,
              firstname: item.firstname,
              lastname: item.lastname,
              screenname: item.screenname,
              avatarUrl: item.avatarUrl,
              cngType: item.type,
              displayName: item.displayName,
            };
            paginationData.pageData.push(dto);
          }
        }
        if (result.data && result.data.nbTotalItems > 0) {
          paginationData.nbTotalItems = result.data.nbTotalItems;
        }
        return paginationData;
      });
  }
}

export default MODULE_NAME;
